import React, { useState } from 'react';
import { api } from '../redux/axios/api';
import { servicios } from '../redux/helpers';

const useUsuario = () => {
  const [processingUser, setProcessingUser] = useState(false);
  const [users, setUsers] = useState([]);

  const getUsersByStore = (su) => {
    setProcessingUser(true);
    api
      .get(`${servicios.USUARIO}/sucursal`, { params: { su } })
      .then((response) => setUsers(response))
      .catch((error) => console.log(error.data))
      .finally(() => setProcessingUser(false));
  };
  return {
    processingUser,
    users,
    getUsersByStore,
  };
};

export default useUsuario;
